import React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

import { CheckCircle } from "@mui/icons-material";

import { useTranslation } from "react-i18next";

const KontaktMessageDialog = (props) => {
    const { open, onClose } = props;
    const { t } = useTranslation();

    return (
        <div>
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={"xs"}
                fullWidth
            >
                <DialogContent>
                    <DialogContentText
                        id="alert-dialog-description"
                        sx={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 2, color:'#000' }}
                    >
                        {t("Wiadomość została wysłana!")}
                        <CheckCircle sx={{ color: "#b9d330", marginLeft:2 }} />
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", marginTop: 3, marginBottom: 3 }}>
                    <Button onClick={onClose} autoFocus variant={"contained"} color={"primary"}>
                        {t("Nowa wiadomość")}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default KontaktMessageDialog;
